export default __webpack_public_path__ + "static/media/download_bg-2.08402c32.png";